import type { ReactNode } from 'react'

import { scotlandTheme } from '../scotlandConfig'

export function SectionHeading({
  children,
  centered = false,
  id,
}: {
  children: ReactNode
  centered?: boolean
  id?: string
}) {
  return (
    <h2
      id={id}
      className={`mb-5 border-b border-stone-400/80 pb-2 font-scotland text-4xl font-bold leading-tight sm:text-[2.75rem] ${scotlandTheme.accentText} ${centered ? 'text-center' : ''}`}
    >
      {children}
    </h2>
  )
}
